import {registerBrick, GlobalProperties} from 'olympe';
import {ReactBrick, useProperty} from '@olympeio/core';
import React from 'react';
import ReactDOM from 'react-dom';
import MUIDialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';

/**
 * This brick display a Dialog for Candex Catalogue
 */
export default class CandexDialogBrick extends ReactBrick {
    /**
     * @override
     */
    init($) {
        $.set('Open', false);
        $.observe('Open Dialog').subscribe(() => $.set('Open', true));
        $.observe('Close Dialog').subscribe(() => $.set('Open', false));
    }

    /**
     * @override
     */
    updateParent(parent, element) {
        parent.style.overflow = 'visible';
        ReactDOM.render(element, parent);
        return () => ReactDOM.unmountComponentAtNode(parent);
    }

    /**
     * @override
     * @param {!BrickContext} $
     * @return {Element}
     */
    static getReactComponent($) {
        return () => {
            const open = useProperty($, 'Open');
            const url = useProperty($, 'URL', true);
            const onLoad = useProperty($, 'On Load', false);

            const handleOnLoad = (event) => {
                const [ctrlFlowInput, eventInput] = onLoad.getInputs();
                const runner = $.runner(onLoad);
                runner.set(eventInput, event);
                runner.trigger(ctrlFlowInput);
            };

            if ($.get(GlobalProperties.EDITION, true)) {
                return null;
            }

            return open ? (
                <MUIDialog
                    open
                    disableEnforceFocus
                    maxWidth={false}
                    scroll="paper"
                    keepMounted={false}
                    onClose={() => {
                        $.set('Open', false);
                        $.trigger('Close iframe');
                    }}
                >
                    <DialogContent sx={{width: 1000, height: 700, p: '5px'}}>
                        <iframe
                            src={url}
                            title="Candex Catalogue"
                            loading="lazy"
                            width={1000}
                            height={700}
                            style={{border: 0}}
                            onLoad={handleOnLoad}
                        />
                    </DialogContent>
                </MUIDialog>
            ) : null;
        };
    }
}

registerBrick('01979bca2f59b605b612', CandexDialogBrick);
